import React from 'react';

import { CustomRoute } from 'util/hook/useRouter';
import { appPath } from 'util/routingConfig';

const routes: CustomRoute = {
	path: appPath.adminApproveBTF.replace(appPath.admin, ''),
	components: () => [import(/* webpackChunkName: 'adminApproveBTF' */ './component')],
	render: ([AdminApproveBTF]) => <AdminApproveBTF />,
};

export default routes;
